/**  Created by joellee on 10/26/15. */
dealershipModule.controller('DealerSettingsController', ['$scope','authorizationService', 'dealershipModuleConstants', 'imSessionVarsService', '$window',
    function($scope, authorizationService, dealershipModuleConstants, imSessionVarsService, $window ) {

         $scope.dSettingviews =  {
            dealerProfile: "DealerProfile",
            lendersManagement: "LendersManagement",
            internetQuoting: "InternetQuoting",
            dealerProductSettings: "DealerProductSettings",
            defaults: "DealerProductSettings"
        };  // none visible yet
        var activeView = $scope.dSettingviews.defaults;

        $scope.setActiveView  = function (viewName) {
            activeView = viewName;
        };

        $scope.isViewActive = function(viewName) {
            return (activeView === viewName) ? true : false;
        };

        $scope.goPreviousView = function(){
            $window.history.back();
        };

        function init() {
            if (imSessionVarsService.getShowcaseIntegrated() == 'true' && imSessionVarsService.getShowcaseIntegratedSetting() == 'Lenders')
                $scope.setActiveView($scope.dSettingviews.lendersManagement);
            else
                $scope.setActiveView(activeView);
            $scope.showInternetQuoting =  authorizationService.isUIElementAccessibleForUser(dealershipModuleConstants.INTERNET_QUOTING);
        }
        init();
    }]);